import React from 'react';
import {jsonLdScript, pageSchema} from "../../helper/schema";
import {Helmet} from "react-helmet";
import Sidebar from "../Common/sidebar";
import FoodCard from "../Common/foodCard";
import API from "../../api";
import {Dropdown} from "react-bootstrap";
import '/src/assets/css/home.css';
import '/src/assets/css/loading.css';
import {withRouter} from "react-router-dom";
import {BASE_URL, CapitalizeFirstLetter} from "../../helper";
import InfiniteScroll from "react-infinite-scroll-component";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {Oval } from 'react-loader-spinner'
import ReactPaginate from 'react-paginate';
import {connect} from "react-redux";
import CategoryPageSidebar from "./CategoryPageSidebar";
const  api = new API();
let timerId ;

class ProductCategory extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show_loader : true,
            array_count: 25,
            filter_data: {keyword: "" ,categories_slug : "", restaurant_id: 2},
            page_meta: null,
            loading : true,
            dropdown :false,
            products : [],
            categories : [],
            categories_slug : null ,
            categories_name : null ,
            storeItem :[],
            range : [0,50],
            is_prime : false ,
            is_bulk : false ,
            lowToHigh : false,
            highToLow : false,
            restaurant_id : 2,
            data: {
                page: 25,
            }
        }
        this.handler = this.handler.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleRedirection = this.handleRedirection.bind(this);
        this.topRedirection = this.topRedirection.bind(this);
    }

    static async getInitialProps({req, res, match, history, location, ...ctx}) {
        let category = '';
        if(match.params.category){
            category = match.params.category;
        }
        const categories = await api.getCategories( {keyword  : "all", category : null});
        var data = {keyword: "" ,categories_slug : category, restaurant_id: 2 };
        const  products = await api.getFilterProduct(data);

        return {
            categories: categories.data.response.categories,
            search_all_products : products.data.response.data,
            page_meta: products.data.response.meta
        }
    }

    handleRedirection(path) {
        this.props.history.push(path);
    }

    topRedirection()
    {
        window.scrollTo(0, 0);
    }

    // fetchMoreData = () => {
    //     setTimeout(() => {
    //         var page = this.state.array_count + 25 ;
    //         let data = this.state.filter_data ;
    //         data.page = page ;
    //         api.getFilterProduct(data).then(products => {
    //             this.setState({
    //                 show_loader : page > products.data.response.data.length ? false : true,
    //                 storeItem: products.data.response.data,
    //                 array_count : page,
    //                 loading: false,
    //                 filter_data: data,
    //                 page_meta: products.data.response.meta
    //             });
    //             this.getSearchProducts();
    //         });
    //     }, 1500);
    // };

    handlePageChange(pageNumber) {
        let data = this.state.filter_data ;
        data.page = pageNumber.selected + 1 ;
        api.getFilterProduct(data).then(products => {
            this.setState({
                loading: false,
                storeItem: products.data.response.data,
                filter_data: data,
                page_meta: products.data.response.meta
            });
            this.getSearchProducts();
        });
    }

    componentDidMount() {

        window.scrollTo(0, 0);

        if(this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() !== null  && this.props.match.params.search_key.toLowerCase() !== "all") {
            this.setState({loading: true});
            this.setState({
                categories_slug: this.props.location.state ? this.props.location.state.categories_slug : this.state.categories_slug,
                categories_name: this.props.location.state ? this.props.location.state.categories_name : this.state.categories_name
            });
            const data = {keyword: this.props.match.params.search_key.toLowerCase() , range: this.state.range ,
                categories_slug : this.props.location.state ? this.props.location.state.categories_slug : null,
                filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk ,
                    lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow  },
                restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2 };
            this.getFilterProducts(data);
        }else{
            this.setState({loading: true});
            this.setState({
                categories_slug : this.props.location.state ? this.props.location.state.categories_slug : null,
                categories_name: this.props.location.state ? this.props.location.state.categories_name : this.state.categories_name
            });
            const data = {keyword: "" ,categories_slug : this.props.location.state ? this.props.location.state.categories_slug : null,
                restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2 };
            this.getFilterProducts(data);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (prevProps.defaultStore !== this.props.defaultStore ) {
            if (this.props.defaultStore ? this.props.defaultStore : 2 !== this.props.defaultStore.store ) {
                this.setState({
                    loading: true,
                    restaurant_id: this.props.defaultStore.store
                });
                const data = {
                    keyword: this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() === "all" ? "" : this.props.match.params && this.props.match.params.search_key ? this.props.match.params.search_key.toLowerCase() : "",
                    range: this.state.range,
                    categories_slug: this.state.categories_slug,
                    filter: {is_prime: this.state.is_prime, is_bulk: this.state.is_bulk},
                    lowToHigh: this.state.lowToHigh,
                    highToLow: this.state.highToLow,
                    restaurant_id: this.props.defaultStore.store
                };
                this.getFilterProducts(data);
            }
        }

        if(prevState.categories_slug !== this.state.categories_slug ) {
            this.setState({loading: true});
            const data = { keyword: this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() === "all" ? "" : this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() ,range: this.state.range ,
                categories_slug : this.state.categories_slug, filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk },
                lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow , restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2 };
            this.getFilterProducts(data);
        }

        if(prevProps.match.params && prevProps.match.params.search_key && prevProps.match.params.search_key.toLowerCase() !== this.props.match.params.search_key.toLowerCase()  ) {
            this.setState({loading: true});
            const data = {keyword: this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() , range: this.state.range , categories_slug : this.state.categories_slug,
                filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk },
                lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow ,restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2};
            this.getFilterProducts(data);
        }

        if(prevState.range[1] !== this.state.range[1]) {
            this.setState({loading: true});
            const data = { keyword: this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() === "all" ? "" : this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key.toLowerCase() ,range: this.state.range ,
                categories_slug : this.state.categories_slug, filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk },
                lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow,restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2 };
            this.getFilterProducts(data);
        }

        if(prevState.lowToHigh !== this.state.lowToHigh || prevState.highToLow !== this.state.highToLow) {
            this.setState({loading: true});
            const data = { keyword: this.props.match.params.search_key.toLowerCase() === "all" ? "" : this.props.match.params.search_key.toLowerCase() ,range: this.state.range ,
                categories_slug : this.state.categories_slug, filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk} ,
                lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow,restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2};
            this.getFilterProducts(data);
        }

        if(prevState.is_prime !== this.state.is_prime || prevState.is_bulk !== this.state.is_bulk || prevState.is_delivery !== this.state.is_delivery || prevState.is_pickup !== this.state.is_pickup){
            this.setState({loading: true});
            const data = { keyword: this.props.match.params.search_key.toLowerCase() === "all" ? "" : this.props.match.params.search_key.toLowerCase() ,range: this.state.range ,
                categories_slug : this.state.categories_slug, filter : { is_prime : this.state.is_prime , is_bulk : this.state.is_bulk } ,
                lowToHigh : this.state.lowToHigh , highToLow : this.state.highToLow,restaurant_id: this.props.defaultStore ? this.props.defaultStore.store : 2};
            this.getFilterProducts(data);
        }
    }

    getFilterProducts(data){
        return true;
        //cancel multiple request
        clearTimeout(timerId);

        //api calling with 500ms delay
        timerId = setTimeout(
            function() {
                api.getFilterProduct(data).then(products => {
                    this.setState({
                        loading: false,
                        storeItem: products.data.response.data,
                        filter_data: data,
                        page_meta: products.data.response.meta
                    });
                    this.getSearchProducts();
                    window.scrollTo(0, 0);
                })
            }
                .bind(this),
            500
        );
    }

    getSearchProducts(){
        const search_products =  this.state.storeItem.map((item) => {
            return <FoodCard key={item.id} val={item} />
        });
        this.setState({products: search_products})
    }

    sortLowToHigh(){
        this.setState({ lowToHigh : true });
        this.setState({ highToLow : false });
    }

    sortHighToLow()
    {
        this.setState({ highToLow : true });
        this.setState({ lowToHigh : false });
    }

    handleClear()
    {
        this.setState({ lowToHigh : false })
        this.setState({ highToLow : false })
    }

    handler = (val) =>
    {
        if(val.range !== null && this.state.range !== val.range){
            if (!(val.range[0] === 0 && val.range[1] === 599)) {
                this.setState({range: val.range})
            }
        }
        if(val.categories_slug !== null && this.state.categories_slug !== val.categories_slug){
            this.setState({
                categories_slug : val.categories_slug,
                categories_name : val.categories_name
            })
        }
        if(val.is_prime !== null && this.state.is_prime !== val.is_prime){
            this.setState({ is_prime : val.is_prime })
        }
        if(val.is_bulk !== null && this.state.is_bulk !== val.is_bulk){
            this.setState({ is_bulk : val.is_bulk })
        }
    }

    render() {

        var filter_products = this.state.storeItem && this.state.storeItem.length ? this.state.storeItem : this.props.search_all_products ;

        return (
            <React.Fragment>
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Farmers Fresh - Home</title>
                    <meta name="description" content="Helmet application" />
                    <meta name="robots" content="index, follow" />
                    <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content="Fresh Chicken Leg Quarters By the Pound - On Sale now!" />
                    <meta property="og:description" content="Fresh Chicken Leg Quarters on Sale and Priced per pound. Hormone free and cut free of charge. The best price and quality at Farmer&#039;s Fresh Meat!" />
                    <meta property="og:url" content={BASE_URL() + this.props.location.pathname} />
                    <meta property="og:site_name" content="Farmer&#039;s Fresh Meat: Houston Meat Market &amp; Butcher Shop" />
                    <meta property="article:publisher" content="https://www.facebook.com/farmersfreshmeat" />
                    <meta property="og:image:width" content="1449" />
                    <meta property="og:image:height" content="1024" />
                    <meta name="twitter:card" content="summary" />
                    <meta name="twitter:creator" content="Farmerfreshmeat" />
                    <meta name="twitter:site" content="Farmerfreshmeat" />
                    <link rel="canonical" href={BASE_URL() + this.props.location.pathname} />
                    {jsonLdScript(pageSchema({type: 'CollectionPage', name: "Farmers Fresh - Home", pathname: this.props.location.pathname}))}
                </Helmet>

                <div className="container-fluid mb-fix">
                    <div className="row">
                        {
                            this.props.match.params.search_key && this.props.match.params.search_key !== " " && this.props.match.params.search_key !== "all" ?
                                <div className="col-md-12 ">
                                    <div className="breadcrumb-details">
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <h3><span className="font-weight-normal">Search results for:</span> {this.props.match.params.search_key !== " " && this.props.match.params.search_key !== "all" ? "“ " + this.props.match.params.search_key + " ”" : "" }</h3>
                                                </li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                                :
                                this.state.categories_name ?
                                    <div className="col-md-12 ">
                                        <div className="breadcrumb-details">
                                            <nav aria-label="breadcrumb">
                                                <ol className="breadcrumb mb-0 pb-1">
                                                    <li className="breadcrumb-item" onClick={()=>this.handleRedirection('/')}><a href="javascript:void(0)">Farmer's Fresh Meat</a></li>
                                                    <li className="breadcrumb-item" onClick={()=>this.handleRedirection('/shop-search/all') }><a href="javascript:void(0)">Shop</a></li>
                                                    <li className="breadcrumb-item active" aria-current="page"><a>{ CapitalizeFirstLetter(this.state.categories_name) }</a></li>
                                                </ol>
                                            </nav>
                                            <h4 className="mb-4">{ CapitalizeFirstLetter(this.state.categories_name) }</h4>
                                        </div>
                                    </div>
                                    : " "
                        }

                        <CategoryPageSidebar handler = { this.handler } prods = {this.props.categories}   dataFromParent={this.props.match.params && this.props.match.params.search_key && this.props.match.params.search_key !== "" ?  this.props.match.params.search_key : "all"  }   />
                        <div className="col-12 col-md-10 col-lg-10 col-xl-9 column">
                            <div className="col-12 info-bar">
                                <div className="row">
                                    <div className="col-md-6 left">
                                        <small><span className="">Showing</span> {this.state.page_meta ? this.state.page_meta.total : this.props.page_meta.total} results</small>
                                    </div>

                                    <div className="col right">
                                        <span className="float-left">Sort by</span>
                                        <Dropdown>
                                            <Dropdown.Toggle
                                                variant=""
                                                id="dropdown-basic"
                                            >
                                                {this.state.dropdown
                                                    ? this.state.dropdown
                                                    : 'Best Match'}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item
                                                    onClick={() => this.handleClear()}
                                                >
                                                    Best Match
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => this.sortLowToHigh(true)}
                                                >
                                                    Price low to high
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    onClick={() => this.sortHighToLow(true)}
                                                >
                                                    Price high to low
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                        {/*<small className="float-right" onClick={() => this.handleClear()}> ClearAll </small>*/}
                                    </div>
                                </div>
                            </div>
                            {/*<InfiniteScroll*/}
                            {/*    dataLength={this.state.storeItem.length}*/}
                            {/*    next={this.fetchMoreData}*/}
                            {/*    hasMore={true}*/}
                            {/*    loader={ this.state.show_loader === false ? "" : <Oval color="#d30000" height={80} width={1200} /> }*/}
                            {/*>*/}
                            <div className="row display-details">
                                {!!filter_products.length ? filter_products.map((item) => {
                                        return <FoodCard key={item.id} val={item} />
                                    }) : ""
                                }
                            </div>
                            {/*</InfiniteScroll>*/}
                            <div className="pagination">
                                <ReactPaginate
                                    previousLabel={<i className="fas fa-chevron-left"></i>}
                                    nextLabel={<i class="fas fa-chevron-right"></i>}
                                    pageCount={this.state.page_meta && this.state.page_meta.length ? this.state.page_meta
                                        : this.props.page_meta.last_page  }
                                    onPageChange={this.handlePageChange.bind(this)}
                                    marginPagesDisplayed={0}
                                    pageRangeDisplayed={5}
                                    containerClassName={'paginationBttns'}
                                    previousLinkClassName={'previousBttn'}
                                    nextLinkClassName={'nextBttn'}
                                    disabledClassName={'paginationDisabled'}
                                    activeClassName={'paginationActive'}
                                />
                            </div>
                        </div>
                    </div>
                    <btn  className="btn-order btn-float" onClick={ () =>{ this.topRedirection()} }>
                        <i className="fas fa-chevron-up"></i>
                    </btn>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        defaultStore: state.StoreReducer.selectedStore,
    };
};

export default withRouter(connect(mapStateToProps,null)(ProductCategory))
